/* eslint-disable import/newline-after-import */
/* Combine all available reducers to a single root reducer.
 *
 * CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
/* Populated by react-webpack-redux:reducer */
import { combineReducers } from 'redux';
import * as authInfoReducers from './authInfoReducer';
import * as usersReducers from './usersReducer';
import * as cipGroupsReducers from './cipGroupsReducer';
import * as cipIdeasReducers from './cipIdeasReducer';
import * as initiativeReducers from './initiativeReducer';

const reducers = {...authInfoReducers, ...cipGroupsReducers, ...cipIdeasReducers,...usersReducers,...initiativeReducers};

const combined = combineReducers(reducers);
module.exports = combined;



// WEBPACK FOOTER //
// ./reducers/index.js